import React from 'react';
import classNames from 'classnames';

interface SpanTextProps {
    className?: string;
    type?: 'error' | 'info' | 'success' | 'warning' | 'primary' | 'default';
    children?: React.ReactNode;
}

const SpanText: React.FC<SpanTextProps> = ({ type = 'default', className, children }) => {
    return <span className={classNames('fx-span-text', type, className)}>{children}</span>;
};

export default SpanText;
